/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CreateUserFromWebLaboratoryAliases {
  BUTTON_CONFIRM_ACTION = 'button-confirm-action',
  CONTEXTUAL_BAR_CREATE_USER_FROM_WEB_LABORATORY = 'contextual-bar-create-user-from-web-laboratory',
  FORM_CREATE_NEW_USER = 'form-create-new-user',
  GLOBAL_ACTIONS_CONFIRMATION_BUTTOM_CREATE_USER_FROM_WEB_LABORATORY = 'global-actions-confirmation-buttom-create-user-from-web-laboratory',
  INPUT_LOGIN = 'input-login',
  LAYOUT_FORMULARY_CREATE_USER_FROM_WEB_LABORATORY = 'layout-formulary-create-user-from-web-laboratory',
  LOADER = 'loader',
  LOGIN_FIELD = 'login-field',
  MODAL_CREATE_USER_FROM_WEB_LABORATORY = 'modal-create-user-from-web-laboratory',
  PANEL_BTNS_ACTIONS = 'panel-btns-actions',
  PANEL_CONTENT_CREATE_USER_FROM_WEB_LABORATORY = 'panel-content-create-user-from-web-laboratory',
  PANEL_FORMULARY_CREATE_USER_FROM_WEB_LABORATORY = 'panel-formulary-create-user-from-web-laboratory',
  PANEL_LOADER = 'panel-loader',
  PASSWORD_CONFIRM_FIELD = 'password-confirm-field',
  PASSWORD_CONFIRM_INPUT = 'password-confirm-input',
  PASSWORD_FIELD = 'password-field',
  PASSWORD_INPUT = 'password-input',
}
export { CreateUserFromWebLaboratoryAliases };
